/**
 * Shared by the admin completion-criteria summary and the learner Journey progress card,
 * so the two views can't drift apart on wording.
 */
export const obligatoryItemsLabel = (count: number): string => `${count} obligatory item${count === 1 ? '' : 's'}`;
